export default[{
        path: '/enrollments',
        name: 'enrollments',
        component: () =>
            import ('@/views/pages/enrollments/enrollments-list/EnrollmentsList.vue'),
        meta: {
            pageTitle: 'Enrollments',
            breadcrumb: [{
                text: 'Enrollments',
                active: true,
                to: '/enrollments'
            }],
            resource: 'enrollment',
            action: 'read'
        },   
    },
    {
        path: '/enrollments/view/:id',
        name: 'enrollments-view',
        component: () => 
            import ('@/views/pages/enrollments/enrollments-view/EnrollmentsView.vue'),
        meta: {
            pageTitle: 'View Enrollment',
            breadcrumb: [
                {
                    text: 'Enrollments',
                    to: '/enrollments'
                },
                {
                    text: 'View',
                    active: true
                }
            ],
            resource: 'enrollment',
            action: 'read'
        }
    },
    {
        path: '/enrollments/add',
        name: 'enrollments-add',
        component: () => 
            import ('@/views/pages/enrollments/enrollments-add/EnrollmentsAdd.vue'),
        meta: {
            pageTitle: 'Add Enrollment',
            breadcrumb: [
            {
                text: 'Enrollments',
                to: '/enrollments',
            },
            {
                text: 'Add',
                active: true,
            }],
            resource: 'enrollment',
            action: 'write'
        }
    },
    {
        path: '/enrollments/edit/:id',
        name: 'enrollments-edit',
        component: () =>
            import ('@/views/pages/enrollments/enrollments-edit/EnrollmentsEdit.vue'),
        meta: {
            pageTitle: 'Edit Enrollment',
            breadcrumb: [
                {
                    text: 'Enrollments',
                    to: '/enrollments',
                },
                {
                    text: 'Edit',
                    active: true
                }
            ],
            resource: 'enrollment',
            action: 'read',
        }
    }
]